import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {Meeting, useEvents} from '../contexts/EventContext';
import { ZoomMeetingsResponse } from '../services/types';
import {FaPlayCircle, FaVideo, FaCalendarAlt} from 'react-icons/fa';
import EventModal from '../features/event/EventModal';
import AcceleratorOptions from '../pages/accelerator'
import { logErrorToServer } from '../logFront/logger';
import LoginToCalenderPage from '../features/auth/LoginToCalenderPage';
export function isEventUpcoming(startTime: string): boolean {
    const now = new Date(); // עכשיו, לפי הדפדפן
    const eventStart = new Date(startTime); // זמן התחלת האירוע

    return now <= eventStart; // true אם האירוע עוד לא התחיל
}

function formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleString('he-IL', {
        timeZone: 'Asia/Jerusalem',
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
}

const Accelerator = () => {
    const [isModalOpen, setModalOpen] = useState(false);
    const {allEvents, setAllEvents} = useEvents();
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [currentMeeting, setCurrentMeeting] = useState<Meeting | null>(allEvents[currentIndex] || null);
    const token = localStorage.getItem('jwtToken');
    const FaPlayCircleIcon = FaPlayCircle as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    const FaCalendarAltIcon = FaCalendarAlt as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    const FaVideotIcon = FaVideo as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    
    const [generalAccessToken, setGeneralAccessToken] = useState(localStorage.getItem('googleCalendarAccessToken'));

    // const getNextMeetings = () => {
    //     axios.post(`${process.env.REACT_APP_API_URL}/zoom/All`, {}, {
    //         headers: { Authorization: `Bearer ${token}` }
    //     })
    //         .then((response) => {
    //             const events: Meeting[] = response.data.data;

    //             // סינון רק אירועים שעוד לא התחילו
    //             const upcomingEvents = events.filter(e => isEventUpcoming(e.start_time));

    //             setAllEvents(upcomingEvents);
    //             if (upcomingEvents.length > 0) {
    //                 setCurrentIndex(0);
    //                 setCurrentMeeting(upcomingEvents[0]);
    //             }
    //         })
    //         .catch((error) => {
    //             logErrorToServer('trying connect to server', 'ERROR', error.message, 'error fetching the meeting');
    //         });
    // };

const getNextMeetings = useCallback(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/zoom/All`, {}, {
        headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
        const events: Meeting[] = (response.data as ZoomMeetingsResponse).data;

        // סינון רק אירועים שעוד לא התחילו
        const upcomingEvents = events.filter(e => isEventUpcoming(e.start_time));

        setAllEvents(upcomingEvents);
        if (upcomingEvents.length > 0) {
            setCurrentIndex(0);
            setCurrentMeeting(upcomingEvents[0]);
        }
    })
    .catch((error) => {
        logErrorToServer('trying connect to server', 'ERROR', error.message, 'error fetching the meeting');
    });
}, [token,setAllEvents]);


    // const checkEndMeetingTime = () => {
    //     if (!currentMeeting || !allEvents || allEvents.length == 0) {
    //         setCurrentMeeting(null);
    //          // No more meetings
    //         return; // No current meeting to check
    //     }
    //     const now = new Date();
    //     const endTime = new Date(currentMeeting?.end_time);
    //     if (endTime < now) {
    //         setCurrentIndex((prevIndex) => {
    //             const nextIndex = prevIndex + 1;
    //             if (nextIndex < allEvents.length) {
    //                 setCurrentMeeting(allEvents[nextIndex]);
    //                 return nextIndex;
    //             }
    //             setCurrentMeeting(null); // No more meetings
    //             return prevIndex; // לא מעדכן אם אין עוד פגישות

    //         });
    //     };
    // }

    const checkEndMeetingTime = useCallback(() => {
    if (!currentMeeting || !allEvents || allEvents.length === 0) {
        setCurrentMeeting(null);
        return; // No current meeting to check
    }
    
    const now = new Date();
    const endTime = new Date(currentMeeting.end_time);
    
    if (endTime < now) {
        setCurrentIndex((prevIndex) => {
            const nextIndex = prevIndex + 1;
            if (nextIndex < allEvents.length) {
                setCurrentMeeting(allEvents[nextIndex]);
                return nextIndex;
            }
            setCurrentMeeting(null); // No more meetings
            return prevIndex; // לא מעדכן אם אין עוד פגישות
        });
    }
}, [currentMeeting, allEvents]);

    useEffect(() => {
        const interval = setInterval(() => {
            checkEndMeetingTime();
        }, 60000);
        return () => clearInterval(interval);
    }, [currentMeeting,checkEndMeetingTime,getNextMeetings]); // ← הופך את הקוד לדינמי ומעודכן
    
    useEffect(() => {
    const token = localStorage.getItem('googleCalendarAccessToken');
    const expiry = localStorage.getItem('googleCalendarAccessTokenExpiry');
    const now = Date.now();

    if (!token || !expiry || now > parseInt(expiry)) {
        // אין טוקן בכלל או שהוא פג תוקף
        setGeneralAccessToken(null);
    } else {
        setGeneralAccessToken(token);
    }
    }, [generalAccessToken]);
    useEffect(() => {
        window.scrollTo(0, 0);

        getNextMeetings(); 
    }, [getNextMeetings]);
    return (
        <>
        {generalAccessToken==null && 
        (
                            <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(0,0,0,0.4)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                    }}
                >
                    <LoginToCalenderPage onLogin={setGeneralAccessToken}/>
         </div>

        )}
        
        <AcceleratorOptions/>
        <div style={containerStyle}>
            <div style={cardStyle}>
                {currentMeeting ? (
                    <>
                        <h1 style={headerStyle}><strong style={boldLabel}>Current Cohort:</strong> {currentMeeting?.title}</h1>

                            <p><strong style={boldLabel}>Focus:</strong> {currentMeeting.title}</p>
                            <p><strong style={boldLabel}>Next Meeting:</strong> {formatDate(currentMeeting?.start_time)}
                            </p>
                            <p><strong style={boldLabel}>Topic:</strong> {currentMeeting.description}</p>
                            <Link to="/zoom" state={{allEvents}}>
                                <button style={buttonStyle}>
                                    <FaVideotIcon style={iconStyle}/>
                                    Join Live Meeting (Via Zoom API)
                                </button>
                            </Link>
                            <p style={{
                                color: '#ccc',
                                fontSize: '14px',
                                marginTop: '10px',
                                textAlign: 'center', // מרכז את הטקסט
                            }}>
                                Requires Zoom account and API integration for full functionality.
                            </p>
                        </>
                    ) : (
                        <h3 style={{color: 'white'}}>No upcoming meetings found.</h3>
                    )}
                </div>
                <div style={cardStyle}>
                    <h1 style={headerStyle}>Upcoming & Past Cohorts</h1>
                    <p style={paragraphStyle}>Explore future opportunities or catch up on previous sessions</p>
                    <p style={paragraphStyle}><strong>Fall 2025:</strong> Blockchain for Legal Transparency
                        (Applications Open Soon)</p>
                    <p style={paragraphStyle}><strong>Winter 2024:</strong> Community Mediation Technologies (View
                        Recordings)</p>
                    <p style={paragraphStyle}><strong>Spring 2024:</strong> Regulatory Sandboxes in Justicetech (View
                        Recordings)</p>
                    <Link to="/meetings-calendar">
                        <button style={buttonStyle}>
                            <FaCalendarAltIcon style={iconStyle}/>
                            View Cohort Scheduler
                        </button>
                    </Link>
                    <button style={buttonStyle} onClick={() => setModalOpen(true)}>
                        <FaPlayCircleIcon style={iconStyle}/>
                        Access Past Recordings
                    </button>
                </div>
                {isModalOpen && (
                    <EventModal isOpen={isModalOpen} onClose={() => setModalOpen(false)}/>
                )}
            </div>
        </>
    );
};
export default Accelerator;
//
// :art: עיצוב inline
//
const containerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'stretch', // שומר על גובה שווה לשני הדיבים
    gap: '40px',
    margin: '40px',
    padding: '40px',
    borderRadius: '16px',
    flexWrap: 'wrap',
    // ביטול הרקע הכחול:
    // backgroundColor: '#0A2342',
};
const cardStyle: React.CSSProperties = {
    // backgroundColor: '#081C36',
    color: '#FFFFFF',
    border: '2px solid hsl(var(--primary))',

    borderRadius: '12px',
    padding: '30px',
    width: '650px',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.4)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
};
const buttonStyle: React.CSSProperties = {
    backgroundColor: 'hsl(var(--primary))',

    color: '#fff',
    border: 'none',
    padding: '14px 20px',
    borderRadius: '8px',
    fontWeight: 'bold',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    width: '100%',
    marginTop: '20px',
    cursor: 'pointer',
};
const headerStyle: React.CSSProperties = {
    color: '#fff',
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
};
const paragraphStyle: React.CSSProperties = {
    color: '#eee',
    marginBottom: '10px',
    fontSize: '16px',
};
const iconStyle: React.CSSProperties = {
    color: 'white',
    fontSize: '18px',
};
const boldLabel: React.CSSProperties = {
    color: '#fff',
    fontWeight: 'bold',
};
